import styled from "styled-components";
import { colors } from "../helpers/functions";

export const FormWrapper = styled.div`
    //position: fixed;
    display: flex;
    flex-direction: column;
    align-items: center;
    /*
    z-index: 998;
    //z-index: 9999;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,.65);
    overflow-y: auto;
    */
    .bt_close{
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        right: -3vw;
        top: -3vw;
        width: 8.3vw;
        height: 8.3vw;
        border: 2px solid #FFFFFF;
        border-radius: 18px;
        background-color: rgba(${colors.naranja_pimiento}, 1);
        p{
            display: flex;
            margin: 0;
            padding: 0;
            font-size: 4.5vw;
            color: rgba(${colors.amarillo_banana}, 1);
        }
    }
    .inner{
        position: relative;
        margin-top: 5vw;
        padding: 5vw;
        width: 90vw;
        background-color: rgba(${colors.marron_tierra}, .95);

        box-shadow: 4px 0px 23px 0px rgba(0,0,0,0.25);
        -webkit-box-shadow: 4px 0px 23px 0px rgba(0,0,0,0.25);
        -moz-box-shadow: 4px 0px 23px 0px rgba(0,0,0,0.25);
    }
    .fields{
        display: flex;
        flex-direction: column;
        width: 100%;
        .field{
            position: relative;
            display: flex;
            flex-direction: column;
            width: 100%;
            margin-bottom: 3vw;
            .show_pass{
                position: absolute;
                right: 7px;
                bottom: 0;
                font-size: 30px;
                line-height: 30px;
                color: rgba(${colors.marron_tierra}, 1);
            }
            .born_date{
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                .born_day,
                .born_month,
                .born_year{
                    width: calc((100% / 3) - 2vw);
                    select{
                        width: 100%;
                    }
                    >label{
                        font-size: 3.5vw;
                        line-height: 3.5vw;
                        font-weight: 700;
                        color: rgba(${colors.blanco_huevo}, 1);
                    }
                }
            }
            >label{
                font-size: 3.5vw;
                line-height: 3.5vw;
                font-weight: 600;
                margin-bottom: 1vw;
                font-weight: 700;
                color: rgba(${colors.blanco_huevo}, 1);
            }
            input,
            select{
                font-size: 3.5vw;
                line-height: 3.5vw;
                font-weight: 400;
                padding: 2.5vw 2.5vw;
                border: 1px solid rgba(${colors.blanco_huevo}, 1);
                background-color: rgba(${colors.blanco_huevo}, 1);
                border-radius: 6px;
                outline: 0;
                &.error{
                    border-color: red;
                }
            }
            &:last-child{
                margin-bottom: 0;
            }
        }
    }
    .aclaration_asterix{
        width: 100%;
        text-align: left;
        margin-top: 3vw;
        font-size: 3vw;
        font-weight: 600;
        color: rgba(${colors.blanco_huevo}, 1);
    }
    .actions{
        margin-top: 20px;
        .loader{
            display: flex;
            justify-content: center;
            align-items: center;
            height: 53px;
            svg{
                color: rgba(${colors.verde_acelga}, 1);
            }
        }
    }

`

export const ButtonStyled = styled.div`
    background-color: rgba(${colors.azul_agua}, 1);
    color: rgba(${colors.blanco_huevo}, 1);
    font-weight: 800;
    text-transform: uppercase;
    text-align: center;
    padding: 16px 30px;
    border-radius: 6px;
    border: 1px solid rgba(${colors.verde_brocoli}, 1);
    cursor: pointer;
    &:hover{
        background-color: rgba(${colors.verde_brocoli}, 1);
        //color: #3DA5E0;
    }
`

export const ButtonTextStyled = styled.div`
    display: flex;
    justify-self: center;
    font-weight: 800;
    font-size: 4.5vw;
    line-height: 4.5vw;
    color: rgba(${colors.blanco_huevo}, 1);
    margin-top: 4.5vw;
`